// extracted by mini-css-extract-plugin
export default {"container":"ProductPage_container__wV0Kh","top":"ProductPage_top__Lbr41","middle":"ProductPage_middle__T3e-0","bottom":"ProductPage_bottom__e+bqI"};